module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label",
    class: {
      'col-sm-4': _vm.horizontal
    }
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('div', {
    class: {
      'col-sm-8': _vm.horizontal
    }
  }, [_c('div', {
    class: {
      'input-group': _vm.hasAddon
    }
  }, [_vm._t("default"), _vm._v(" "), (_vm.hasAddon) ? _c('span', {
    staticClass: "input-group-btn"
  }, [_vm._t("addon")], 2) : _vm._e()], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9b1a9dd4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FormGroup.vue
// module id = 267
// module chunks = 1